module.exports = __webpack_public_path__ + "Roboto-RegularItalic.527502d7927a41ca0b6a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.svg
// module id = 107
// module chunks = 16